import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import imghero from "../../assets/hero.png"
import imgherodos from "../../assets/a12.png"

const Hero = () => {
    return (
        <section className="relative w-full min-h-screen flex flex-col bg-white overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 mt-24 grid md:grid-cols-2 gap-12 items-center flex-1">

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="col-span-2 flex flex-col items-center text-center"
                >
                    {/* LOGO (Sutil y elegante) */}
                    <div className="flex items-center text-4xl md:text-5xl font-black tracking-tighter">
                        {/* Cambiamos PLAN a un gris oscuro para que no compita tanto con el título */}
                        <span className="text-gray-800">PLAN</span>
                        <span className="text-[#F26B1D] ml-1">IX</span>
                    </div>

                    {/* TITULO PRINCIPAL */}
                    <motion.h1
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="mt-6 text-4xl md:text-6xl font-extrabold text-gray-900 leading-[1.1] max-w-2xl"
                    >
                        {/* Mantenemos el naranja solo en 'construir' para mantener el foco */}
                        Diseño de planos <br />
                        listos para <span className="text-[#F26B1D]">construir</span>
                    </motion.h1>

                    {/* SUBTITULO (Sintetizado) */}
                    <motion.p
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="mt-6 text-lg md:text-xl text-gray-500 max-w-xl leading-relaxed"
                    >
                        Encuentra un plano que te sirva como base y adáptalo según tu necesidad.
                    </motion.p>

                    {/* BOTONES (Más limpios) */}
                    <motion.div
                        className="mt-10 flex flex-col sm:flex-row gap-4 justify-center relative z-30"
                    >
                        <Link to="/planos" className="w-full sm:w-auto">
                            <motion.div
                                whileTap={{ scale: 0.95 }}
                                whileHover={{ scale: 1.05 }}
                                className="px-8 py-4 bg-[#F26B1D] text-white font-bold rounded-2xl shadow-lg text-center cursor-pointer"
                            >
                                Ver Planos
                            </motion.div>
                        </Link>

                        <Link to="/servicios" className="w-full sm:w-auto">
                            <motion.div
                                whileTap={{ scale: 0.95 }}
                                whileHover={{ scale: 1.05 }}
                                className="px-8 py-4 border-2 border-gray-200 text-gray-700 font-bold rounded-2xl text-center cursor-pointer"
                            >
                                Necesito asesoría
                            </motion.div>
                        </Link>
                    </motion.div>

                    {/* CONFIANZA (Minimalista) */}
                    <div className="mt-8 flex items-center gap-6 text-xs font-bold text-gray-400 uppercase tracking-widest">
                        <span>✓ Listos para usar</span>
                        <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                        <span>✓ Soporte Técnico</span>
                        <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                        <span>✓ Asesoría Especializada</span>
                    </div>
                </motion.div>

            </div>

            <div className="absolute right-0 top-0 w-[500px] h-[500px] bg-[#F26B1D]/5 rounded-full blur-3xl"></div>

            <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-2 gap-12 items-center">

                <motion.div
                    initial={{ opacity: 0, x: 40, y: 0 }}
                    animate={{ opacity: 1, x: 0, y: [0, -12, 0] }}
                    transition={{
                        opacity: { duration: 1 },
                        x: { duration: 1 },
                        y: {
                            duration: 4,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }
                    }}
                    className="relative flex justify-center"
                >
                    <div className="p-8 rounded-2xl border-gray-100 relative">

                        <img
                            src={imghero}
                            alt="Plano arquitectónico"
                            className="object-contain drop-shadow-xl"
                        />

                        <div className="absolute -bottom-6 -right-6 bg-[#F26B1D] w-24 h-24 rounded-full blur-2xl opacity-30"></div>

                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="flex flex-col gap-6"
                >
                    <div>
                        <h2 className="text-3xl font-black text-[#1C1C1C] tracking-tight">
                            ¿En qué podemos ayudarte?
                        </h2>
                        <p className="text-gray-500 mt-2 text-lg">
                            Soluciones técnicas integrales para tu propiedad.
                        </p>
                    </div>

                    <div className="grid gap-3 mt-2">
                        {[
                            { name: "Catálogo de Planos Listos", id: "planos", icon: "📄" },
                            { name: "Elaboración de planos y diseño", id: "diseno", icon: "📐" },
                            { name: "Regularización de predios", id: "regularizacion", icon: "🏠" },
                            { name: "Servicios Topográficos", id: "topografia", icon: "📍" },
                            { name: "Trámites prediales", id: "tramites", icon: "⚖️" }
                        ].map((service, index) => (
                            <motion.a
                                key={index}
                                href={`#${service.id}`}
                                whileHover={{ x: 10 }} // Efecto de desplazamiento al pasar el mouse
                                className="group flex items-center justify-between px-6 py-5 bg-white border border-gray-100 rounded-2xl shadow-sm hover:border-[#F26B1D] hover:shadow-md hover:shadow-[#F26B1D]/5 transition-all"
                            >
                                <div className="flex items-center gap-4">
                                    <span className="text-2xl bg-gray-50 w-12 h-12 flex items-center justify-center rounded-xl group-hover:bg-[#F26B1D]/10 transition-colors">
                                        {service.icon}
                                    </span>
                                    <span className="font-bold text-gray-700 group-hover:text-gray-900 transition-colors">
                                        {service.name}
                                    </span>
                                </div>

                                <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-[#F26B1D] transition-all">
                                    <svg
                                        className="w-4 h-4 text-gray-400 group-hover:text-white transition-colors"
                                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </motion.a>
                        ))}
                    </div>

                    <p className="text-sm text-gray-400 font-medium italic">
                        * Brindamos asesoría técnica personalizada en todo Lima.
                    </p>
                </motion.div>

            </div>

            <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-2 gap-12 items-center" id="diseno">
                {/* Imagen */}
                <motion.div
                    initial={{ opacity: 0, x: 60 }}
                    animate={{
                        opacity: 1,
                        x: 0,
                        y: [0, -15, 0],
                        rotate: [0, 0.5, -0.5, 0] // Reducido para evitar saltos visuales
                    }}
                    transition={{
                        opacity: { duration: 1 },
                        x: { duration: 1 },
                        y: {
                            duration: 4,
                            repeat: Infinity,
                            ease: "easeInOut"
                        },
                        rotate: {
                            duration: 6,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }
                    }}
                    className="flex justify-center items-center" // Centrado total
                >
                    <img
                        src={imgherodos}
                        alt="Planos arquitectónicos"
                        className="w-[320px] sm:w-[420px] md:w-[500px] lg:w-[550px] h-auto object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.2)]"
                    />
                </motion.div>

                {/* Texto */}
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1 }}
                    className="text-center md:text-left"
                >
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                        El diseño ideal <br />
                        <span className="text-[#F26B1D]">para tu propiedad</span>
                    </h2>

                    <p className="mt-6 text-lg text-gray-600 max-w-lg">
                        Explora nuestro catálogo de planos listos para usar o solicita un
                        <span className="text-gray-900 font-semibold"> diseño 100% personalizado</span>.
                        Nos adaptamos a las medidas de tu terreno y tus necesidades.
                    </p>

                    <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                        {/* Camino A: Comprar lo que ya existe */}
                        <Link
                            to="/planos"
                            className="bg-[#F26B1D] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#d95c14] transition shadow-lg shadow-[#F26B1D]/20 text-center"
                        >
                            Ver Catálogo
                        </Link>

                        {/* Camino B: Servicio personalizado */}
                        <Link
                            to="/contacto"
                            className="border-2 border-gray-200 text-gray-700 px-8 py-3 rounded-xl font-bold hover:border-[#F26B1D] hover:text-[#F26B1D] transition text-center"
                        >
                            Diseño Personalizado
                        </Link>
                    </div>

                    {/* Nota aclaratoria sutil */}
                    <p className="mt-4 text-sm text-gray-400 italic">
                        ¿Tienes un terreno con medidas especiales? Nosotros lo resolvemos.
                    </p>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;